import { TimeSlot } from "@hubcapp/types";
import { TimeSlotListItem } from "@hubcapp/components/Calendar/components/Modals/AddLessonModal/components/TimeSlotListItem";
import { makeStyles } from "@material-ui/core";
import Label from "@ds-developer/label";
import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles(() => ({
  title: {
    marginBottom: 16,
  },
  list: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  conflictBlock: {
    marginBottom: 16,
  },
  skeleton: {
    marginBottom: 16,
    paddingBottom: 16,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
}));

interface Props {
  timeSlots: TimeSlot[] | undefined;
  loadingTimeSlots?: boolean;
  repeatingLessonFrequencyNumber?: number | null;
}

export type lessonPaidStatus = "Pre-paid" | "Not-paid";

export const BookingConflictTable: React.FC<Props> = ({
  timeSlots,
  loadingTimeSlots,
  repeatingLessonFrequencyNumber,
}) => {
  const classes = useStyles();
  const conflictingTimeSlots = timeSlots?.filter(
    timeSlot => timeSlot.availability === false,
  );

  const bookedTimeSlots = timeSlots?.filter(
    timeSlot => timeSlot.availability === true,
  );

  return (
    <>
      {loadingTimeSlots &&
      repeatingLessonFrequencyNumber &&
      repeatingLessonFrequencyNumber > 0 ? (
        <ul className={classes.list}>
          {Array.from({ length: repeatingLessonFrequencyNumber }).map(
            (_, i) => (
              <div key={i} className={classes.skeleton}>
                <Skeleton
                  animation="wave"
                  variant="rect"
                  width={210}
                  height={16}
                />
              </div>
            ),
          )}
        </ul>
      ) : (
        <>
          {conflictingTimeSlots?.length && conflictingTimeSlots?.length > 0 ? (
            <div className={classes.conflictBlock}>
              <div className={classes.title}>
                <b>{conflictingTimeSlots?.length} lesson(s):</b> can not be
                booked:
              </div>
              <ul className={classes.list}>
                {conflictingTimeSlots?.map(timeSlot => (
                  <TimeSlotListItem
                    key={timeSlot.startDateTime}
                    timeSlot={timeSlot}
                    label={
                      <Label color="error">
                        {timeSlot.insufficientBalanceForBooking
                          ? "Insufficient hours"
                          : "Booking conflict"}
                      </Label>
                    }
                    status={null}
                  />
                ))}
              </ul>
            </div>
          ) : null}
          <>
            <div className={classes.title}>
              You’re able to book{" "}
              <b>
                {bookedTimeSlots?.length || 0}/{timeSlots?.length}
              </b>
              &nbsp;lessons:
            </div>
            <ul className={classes.list}>
              {bookedTimeSlots?.map(timeSlot => (
                <TimeSlotListItem
                  key={timeSlot.startDateTime}
                  timeSlot={timeSlot}
                  label={<Label color="success">Free</Label>}
                  status={timeSlot.prepaid ? "Pre-paid" : "Not-paid"}
                />
              ))}
            </ul>
          </>
        </>
      )}
    </>
  );
};
